import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "../../api/client";
import { StatePanel } from "../../components/ui";
export function PaymentReturnPage() {
  const query = useQuery({
    queryKey: ["payment-return-status"],
    queryFn: api.reservations,
    refetchInterval: (q) =>
      q.state.data?.[0]?.stages.some(
        (stage) => stage.paymentStatus === "pending",
      )
        ? 2500
        : false,
  });
  return (
    <div className="page">
      <StatePanel
        icon="◷"
        title="Checking your payment"
        body="We’re waiting for server confirmation from Whish. Don’t close the app just yet."
        action={
          <Link className="button button--secondary" to="/reservations/res-001">
            View booking status
          </Link>
        }
      />
      {query.isError && (
        <p role="alert">
          We couldn’t refresh the status. Your booking will not show as
          confirmed unless payment is verified.
        </p>
      )}
    </div>
  );
}
